module.exports = __webpack_public_path__ + "media/assets/images/caret-down-ac2309c34770982b8f41f1b891be7a58.svg";